import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, green } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityLightTokens, unityDarkTokens } from '@/theme/unityTokens';

export const successColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  const { panwRebrandStubYear } = opts;
  if (panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--data-informative-positive'],
          highContrast: unityLightTokens['--data-informative-positive-high-contrast'],
          lowContrast: unityLightTokens['--data-informative-positive-low-contrast'],
        }
      : {
          main: unityDarkTokens['--data-informative-positive'],
          highContrast: unityDarkTokens['--data-informative-positive-high-contrast'],
          lowContrast: unityDarkTokens['--data-informative-positive-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: green[500],
        highContrast: green[700],
        lowContrast: green[100],
      }
    : {
        main: green[400],
        highContrast: green[100],
        lowContrast: green[800],
      };
};
